import { useLanguage } from '../../i18n/LanguageContext';

interface SuccessModalProps {
  onSignIn: () => void;
}

export default function SuccessModal({ onSignIn }: SuccessModalProps) {
  const { t } = useLanguage();

  return (
    <div className="auth-modal-backdrop">
      <div className="auth-modal">
        <div className="success-modal-content">
          <div className="success-icon">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="10" fill="#16a34a"/>
              <path d="M8 12l3 3 5-5" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <h2>{t('auth.success.title')}</h2>
          <p>{t('auth.success.subtitle')}</p>
          <div className="form-actions">
            <button type="button" className="btn btn-primary" onClick={onSignIn}>
              {t('auth.signIn')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
